import { ref } from 'vue';

//Get isMobile
export const isMobile = ref(false);
export const isTablet = ref(false);


//Function to format decimals
export const formatDecimals = (num: number, isoCode: string) => {
    // Formatear los números para que sigan el ISO y el número de decimales
    return new Intl.NumberFormat(isoCode, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
};

//Function to remove string accents
export const removeAccents = (text: string): string => {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

//Function to extract the first 8 characters of the uuid v4
// export const formatId = (uuid:string): string =>{
//     return uuid.slice(0,8);
// }


export async function formatId(uuid: string, length: number = 8): Promise<string> {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

    const base62Encode = (bigInt: bigint): string => {
        let output = '';
        while (bigInt > 0n) {
            output = chars[Number(bigInt % 62n)] + output;
            bigInt = bigInt / 62n;
        }
        return output;
    };

    const buffer = new TextEncoder().encode(uuid);
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
    const hashArray = new Uint8Array(hashBuffer);

    const slice = hashArray.slice(0, 7); // ~56 bits
    let bigIntVal = 0n;
    for (const byte of slice) {
        bigIntVal = (bigIntVal << 8n) + BigInt(byte);
    }

    return base62Encode(bigIntVal).padStart(length, '0').toUpperCase();
}

//Function to scroll to Element
export const scrollToElementByClass = (classItem: string):void => {
    const elem = (classItem!=='') && document.querySelector('.'+classItem);
    elem && elem.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

//Function to validate NIF/CIF
export const nifCifValidation =(value:string) => {
    const nif = value.toUpperCase();
  
    // NIF validation (DNI + letter: 8 numbers + letter)
    const nifRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
    if (nifRegex.test(nif)) {
      const letras = 'TRWAGMYFPDXBNJZSQVHLCKE';
      const numero = parseInt(nif.substring(0, 8), 10);
      const letra = nif.charAt(8);
      return letras.charAt(numero % 23) === letra;
    }
  
    // CIF (Business)
    const cifRegex = /^[ABCDEFGHJNPQRSUVW][0-9]{7}[0-9A-J]$/;
    if (cifRegex.test(nif)) {
      let even = 0;
      let odd = 0;
  
      for (let i = 1; i < 8; i += 2) {
        const n = parseInt(nif.charAt(i), 10) * 2;
        odd += Math.floor(n / 10) + (n % 10);
      }
  
      for (let i = 2; i < 7; i += 2) {
        even += parseInt(nif.charAt(i), 10);
      }
  
      const add = even + odd;
      const control = (10 - (add % 10)) % 10;
      const last = nif.charAt(8);
  
      // Control types: number or letter depending on the first letter
      const isNumber = !isNaN(Number(last));
      const isLetter = /[A-J]/.test(last);
      const controlLetters = 'JABCDEFGHI';
  
      if (isNumber) {
        return control === parseInt(last, 10);
      } else if (isLetter) {
        return last === controlLetters[control];
      }
  
      return false;
    }
  
    return false;
  }